import React, { FC, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ENotificationDB } from 'data/types/notifications.types';
import { notificationsMapper } from 'data/datas/notificationsData';
import { useAppDispatch } from 'redux/store';
import appSlice from 'redux/slice/app.slice';
import { notificationConverter } from 'data/converters/notifications.converters';

// Todo: add user profile types and converters after change their apis
export const NotificationsRedirectLayer: FC<{ children: ChildNode; profile: { type: ENotificationDB } }> = ({
  children,
  profile,
}) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  useEffect(() => {
    const actionType = notificationConverter.fromDb(searchParams.get('actionType') as ENotificationDB);
    const resourceId = searchParams.get('resourceId');
    if (searchParams.get('actionType')) {
      const notificationObj = notificationsMapper[actionType];
      if (!notificationObj) return;
      let { url } = notificationObj;
      if (resourceId) {
        url += `/${resourceId}`;
      }
      if (!notificationObj.private) {
        history.push(url);
        return;
      }
      // this link will be set in private routes
      dispatch(appSlice.actions.setCurrentNotificationUrl(url));
    }
  }, []);

  return <>{children}</>;
};
